/* eslint-disable max-len */
import * as yup from 'yup';

const ERROS = {
    CAMPOS_OBRIGATORIOS: 'O campo é obrigatório',
    TERMO_ESCOLAR_ATAS_REUNIOES_UUID_OBRIGATORIO: 'Você deve informar o documento da reunião do CMDRS',
    TERMO_ESCOLAR_ATO_NORMATIVO_UUID_OBRIGATORIO: 'Você deve informar o documento do ato normativo',
}

export const complianceTermValidationSchema = yup.object({
    termo_escolar_pmaf_elaborado: yup.boolean().nullable().required(ERROS.CAMPOS_OBRIGATORIOS),
    termo_escolar_pmaf_validado_seaf_mt: yup.boolean().nullable().required(ERROS.CAMPOS_OBRIGATORIOS),
    termo_escolar_ato_normativo_publicado: yup.boolean().nullable().required(ERROS.CAMPOS_OBRIGATORIOS),
    termo_escolar_cmdrs_constituido: yup.boolean().nullable().required(ERROS.CAMPOS_OBRIGATORIOS),
    termo_escolar_atas_reunioes_uuid: yup.string().nullable().when('termo_escolar_cmdrs_constituido', {
        is: true,
        then: yup.string().required(ERROS.TERMO_ESCOLAR_ATAS_REUNIOES_UUID_OBRIGATORIO),
        otherwise: yup.string().nullable(),
    }),
    termo_escolar_ato_normativo_uuid: yup.string().nullable().when('termo_escolar_ato_normativo_publicado', {
        is: true,
        then: yup.string().required(ERROS.TERMO_ESCOLAR_ATO_NORMATIVO_UUID_OBRIGATORIO),
        otherwise: yup.string().nullable(),
    }),
})